export default __webpack_public_path__ + "static/media/COMMENTEME.79230848.webp";